import { useSyncExternalStore } from "react";

/**
 * True while a CSS media query matches, for the few places where a layout is a different component
 * rather than different CSS (the week grid at 1024px and up, the day list below it). Rendering both
 * and hiding one with CSS would fetch and mount twice as much, and put every session on the page
 * twice for a screen reader.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === "undefined" || !window.matchMedia) return () => {};
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    () => (typeof window !== "undefined" && window.matchMedia ? window.matchMedia(query).matches : false),
    () => false,
  );
}

/** The desktop shell's breakpoint, the same 1024px as the sidebar. */
export const DESKTOP_QUERY = "(min-width: 1024px)";
